import Lookup from 'src/componentes/select2';

const ClassificacaoRiscoLookup = ({ clearable = false, ...props }) => {
  return (
    <Lookup
      labelKey="descricao"
      valueKey="id"
      url="/MatrizRiscoLookup"
      clearable={clearable}
      {...props}
    />
  );
};

export default ClassificacaoRiscoLookup;
